import * as React from 'react';
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {Option, option} from "ts-option";
import Lead from "../../../model/lead/Lead";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import SelectLeadStatus from "./SelectLeadStatus";
import Toast from "../../helper/Toast";
import {fetchLeadEvents, updateLeadStatus} from "../../../store/action/lead/lead";
import LeadStatus from "../../../model/lead/LeadStatus";
import {getLoggedUser} from "../../../store/view/user";
import {UserPermission} from "../../../model/user/UserPermission";

interface IComponentProps {
	/**
	 * Lead.
	 */
	lead: Lead;
}

interface IDispatchProps {
	/**
	 * Update lead status.
	 * @param {string} leadId Lead Id to be updated.
	 * @param {string} status New lead status.
	 * @param {OnSuccess} onSuccess Success callback.
	 * @param {OnFailure} onFailure Failure callback.
	 */
	updateLeadStatus: (leadId: string, status: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Fetch lead history.
	 * @param {string} leadId lead identifier.
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	fetchLeadHistory: (leadId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = IComponentProps & IDispatchProps;

class LeadStatusSelector extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
	}

	leadStatusList: LeadStatus[] = [];

	render() {
		return (
			<div className={"c-lead-status-selector"}>
				<SelectLeadStatus
					selectedId={option(this.props.lead.statusId)}
					clearable={false}
					onChanged={this.handleChange}
					disabled={getLoggedUser().map(user => !user.hasPermissions([UserPermission.LeadStatusUpdate])).getOrElse(true)}/>
			</div>
		);
	}

	/**
	 * Handle status change.
	 * @param {string} selectedStatus New lead status id.
	 */
	handleChange(selectedStatus: Option<LeadStatus>) {
		selectedStatus.map((status: LeadStatus) => {
			if (status.id != this.props.lead.statusId) {
				this.props.updateLeadStatus(
					this.props.lead.id,
					status.id,
					() => {
						this.props.fetchLeadHistory(this.props.lead.id, () => {}, () => {});
					},
					() => Toast.error("Could not update Lead status", "Lead update error"))
			}
		});
	}

}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateLeadStatus: (leadId: string, status: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateLeadStatus(leadId, status, onSuccess, onFailure)),
		fetchLeadHistory: (leadId: string, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(fetchLeadEvents(leadId, onSuccess, onFailure))
	}
}

export default connect(null, mapDispatchToProps)(LeadStatusSelector);